import React, { useId, useMemo } from 'react';
import Icon from '@ant-design/icons';
import { IconComponentProps } from '@ant-design/icons/lib/components/Icon';

import { brandGradientTokens } from '../../../theme';

export interface AIStarsIconProps extends IconComponentProps {
  gradientStart?: string;
  gradientEnd?: string;
}

export const AIStarsIcon = ({ gradientStart, gradientEnd, ...props }: AIStarsIconProps) => {
  const gradientId = `starsGradient${useId().replace(/:/g, '')}`;

  const startColor = gradientStart ?? `var(--bc-brand-gradient-start, ${brandGradientTokens.brandGradientStart})`;
  const endColor = gradientEnd ?? `var(--bc-brand-gradient-end, ${brandGradientTokens.brandGradientEnd})`;

  const AIStarsSvg = useMemo(() => {
    const Svg = () => (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 22" width="1em" height="1em">
        <path fill={`url(#${gradientId})`}
              d="M9.55385 16.7751L10.4315 14.7649C11.2126 12.9761 12.6184 11.5521 14.372 10.7737L16.7877 9.70139C17.5557 9.36049 17.5557 8.24317 16.7877 7.90226L14.4474 6.86343C12.6487 6.06501 11.2177 4.5883 10.45 2.73843L9.56095 0.596223C9.23105 -0.198742 8.13264 -0.19874 7.80275 0.596223L6.91372 2.73841C6.14602 4.5883 4.71498 6.06501 2.9163 6.86343L0.576033 7.90226C-0.19201 8.24317 -0.192011 9.36049 0.576033 9.70139L2.99175 10.7737C4.74534 11.5521 6.15116 12.9761 6.9322 14.7649L7.80985 16.7751C8.14721 17.5477 9.21645 17.5477 9.55385 16.7751ZM18.3409 21.6694L18.5877 21.1037C19.0277 20.0951 19.8202 19.292 20.809 18.8527L21.5694 18.5148C21.9807 18.3321 21.9807 17.7344 21.5694 17.5517L20.8516 17.2327C19.8373 16.7821 19.0306 15.9493 18.5981 14.9064L18.3447 14.2951C18.168 13.8691 17.579 13.8691 17.4023 14.2951L17.1489 14.9064C16.7165 15.9493 15.9098 16.7821 14.8955 17.2327L14.1776 17.5517C13.7664 17.7344 13.7664 18.3321 14.1776 18.5148L14.938 18.8527C15.9269 19.292 16.7193 20.0951 17.1593 21.1037L17.4062 21.6694C17.5868 22.0835 18.1602 22.0835 18.3409 21.6694Z"/>
        <defs>
          <linearGradient id={gradientId} x1="0" x2="21.8778" y1="21.98" y2="21.98" gradientUnits="userSpaceOnUse">
            <stop stopColor={startColor}/>
            <stop offset="1" stopColor={endColor}/>
          </linearGradient>
        </defs>
      </svg>
    );
    return Svg;
  }, [gradientId, startColor, endColor]);

  return <Icon component={AIStarsSvg} {...props} />;
};
